import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { IntroStatement } from "@/components/site/IntroStatement";
import { Services } from "@/components/site/Services";
import { CaseStudy } from "@/components/site/CaseStudy";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Gallery } from "@/components/site/Gallery";
import { Materials } from "@/components/site/Materials";
import { Process } from "@/components/site/Process";
import { WhyUs } from "@/components/site/WhyUs";
import { About } from "@/components/site/About";
import { Coverage } from "@/components/site/Coverage";
import { ContactForm } from "@/components/site/ContactForm";
import { Faq } from "@/components/site/Faq";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";
import { StickyMobileBar } from "@/components/site/StickyMobileBar";

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <IntroStatement />
        <Services />
        <CaseStudy />
        <BeforeAfter />
        <Gallery />
        <Materials />
        <Process />
        <WhyUs />
        <About />
        <Coverage />
        <ContactForm />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
